import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ISO8601Date: any;
  ISO8601DateTime: any;
  Money: any;
  Upload: any;
};

/** A client */
export type Client = {
  __typename?: 'Client';
  /** Creation date */
  createdAt: Scalars['ISO8601DateTime'];
  /** Unique client email */
  email: Scalars['String'];
  /** First name */
  firstName: Scalars['String'];
  /** Full name */
  fullName: Scalars['String'];
  /** Primary key */
  id: Scalars['ID'];
  /** Last name */
  lastName: Scalars['String'];
  /** Client status */
  status: Scalars['String'];
  /** Amount of pending todos */
  todoCount: Scalars['Int'];
};

/** The connection type for Client. */
export type ClientConnection = {
  __typename?: 'ClientConnection';
  /** A list of edges. */
  edges: Array<ClientEdge>;
  /** A list of nodes. */
  nodes: Array<Client>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Arguments for creating a client */
export type ClientCreateInput = {
  /** Client email */
  email: Scalars['String'];
  /** Client first name */
  firstName: Scalars['String'];
  /** Client last name */
  lastName: Scalars['String'];
};

/** Options for creating a client */
export type ClientCreateOptionsInput = {
  /** Client email */
  skipLeaseApplication?: InputMaybe<Scalars['Boolean']>;
};

/** An edge in a connection. */
export type ClientEdge = {
  __typename?: 'ClientEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Client>;
};

/** Arguments for updating a client */
export type ClientUpdateInput = {
  /** Client email */
  email?: InputMaybe<Scalars['String']>;
  /** Client first name */
  firstName?: InputMaybe<Scalars['String']>;
  /** Client last name */
  lastName?: InputMaybe<Scalars['String']>;
};

/** A contract */
export type Contract = {
  __typename?: 'Contract';
  /** Contract client */
  client: Client;
  /** Documents that belong to the contract */
  documents: DocumentConnection;
  /** End date */
  endOn: Scalars['ISO8601Date'];
  /** Primary key */
  id: Scalars['ID'];
  /** Contract location */
  location: Location;
  /** Start date */
  startOn: Scalars['ISO8601Date'];
  /** Suite under this contract */
  suite: Scalars['Int'];
  /** Date in which all related documents were signed */
  usedAt?: Maybe<Scalars['ISO8601DateTime']>;
};


/** A contract */
export type ContractDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for Contract. */
export type ContractConnection = {
  __typename?: 'ContractConnection';
  /** A list of edges. */
  edges: Array<ContractEdge>;
  /** A list of nodes. */
  nodes: Array<Contract>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Arguments for creating a contract */
export type ContractCreateInput = {
  baseRent: Scalars['Money'];
  clientId: Scalars['ID'];
  endOn: Scalars['ISO8601Date'];
  locationId: Scalars['ID'];
  securityDeposit: Scalars['Money'];
  startOn: Scalars['ISO8601Date'];
  suite: Scalars['Int'];
  weeklyRent: Scalars['Money'];
};

/** Options for creating a contract */
export type ContractCreateOptionsInput = {
  skipEsign?: InputMaybe<Scalars['Boolean']>;
};

/** An edge in a connection. */
export type ContractEdge = {
  __typename?: 'ContractEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Contract>;
};

/** A document */
export type Document = Target & {
  __typename?: 'Document';
  /** Client to which this document's owner belongs to */
  client: Client;
  /** Creation date */
  createdAt: Scalars['ISO8601DateTime'];
  /** Document description */
  description: Scalars['String'];
  /** Indicates if the document requries eSignature */
  esign: Scalars['Boolean'];
  /** Link to eSign this document */
  esignLink?: Maybe<Scalars['String']>;
  /** Expiration date */
  expiresOn?: Maybe<Scalars['ISO8601Date']>;
  /** File url */
  fileUrl?: Maybe<Scalars['String']>;
  /** Unique folder containing this document */
  folderName: Scalars['String'];
  /** Primary key */
  id: Scalars['ID'];
  /** Document Name */
  name: Scalars['String'];
  /** This document does no expire */
  nonExpiring: Scalars['Boolean'];
  /** Document status */
  status: Scalars['String'];
  /** To-dos associated with the document */
  todos: TodoConnection;
};


/** A document */
export type DocumentTodosArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for Document. */
export type DocumentConnection = {
  __typename?: 'DocumentConnection';
  /** A list of edges. */
  edges: Array<DocumentEdge>;
  /** A list of nodes. */
  nodes: Array<Document>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type DocumentEdge = {
  __typename?: 'DocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Document>;
};

/** Arguments for updating a document as a guest */
export type DocumentGuestUpdateInput = {
  file?: InputMaybe<Scalars['Upload']>;
};

export enum DocumentOwnerType {
  Contract = 'CONTRACT',
  LeaseApplication = 'LEASE_APPLICATION'
}

/** Arguments for renewing a document */
export type DocumentRenewInput = {
  esign: Scalars['Boolean'];
  esignTemplateId?: InputMaybe<Scalars['String']>;
  expiresOn?: InputMaybe<Scalars['ISO8601Date']>;
  file?: InputMaybe<Scalars['Upload']>;
  nonExpiring?: InputMaybe<Scalars['Boolean']>;
};

/** A template for creating documents */
export type DocumentTemplate = {
  __typename?: 'DocumentTemplate';
  /** eSign template ID */
  esignTemplateId: Scalars['String'];
  /** Primary key */
  id: Scalars['ID'];
  /** Name */
  name: Scalars['String'];
};

/** The connection type for DocumentTemplate. */
export type DocumentTemplateConnection = {
  __typename?: 'DocumentTemplateConnection';
  /** A list of edges. */
  edges: Array<DocumentTemplateEdge>;
  /** A list of nodes. */
  nodes: Array<DocumentTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type DocumentTemplateEdge = {
  __typename?: 'DocumentTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<DocumentTemplate>;
};

/** Arguments for updating a document */
export type DocumentUpdateInput = {
  expiresOn?: InputMaybe<Scalars['ISO8601Date']>;
  nonExpiring?: InputMaybe<Scalars['Boolean']>;
};

/** A lease application */
export type LeaseApplication = {
  __typename?: 'LeaseApplication';
  /** link to eSign the document */
  documentLink?: Maybe<Scalars['String']>;
  /** Primary key */
  id: Scalars['ID'];
  /** Date in which the related document was signed */
  usedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** A location */
export type Location = {
  __typename?: 'Location';
  /** The address of this location */
  address: Scalars['String'];
  /** List of available suites */
  availableSuites: Array<Scalars['Int']>;
  /** Contracts */
  contracts: ContractConnection;
  /** Primary key */
  id: Scalars['ID'];
  /** Number of suites in this location */
  maxSuites: Scalars['Int'];
  /** The name of this location */
  name: Scalars['String'];
};


/** A location */
export type LocationContractsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for Location. */
export type LocationConnection = {
  __typename?: 'LocationConnection';
  /** A list of edges. */
  edges: Array<LocationEdge>;
  /** A list of nodes. */
  nodes: Array<Location>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Arguments for creating a location */
export type LocationCreateInput = {
  address: Scalars['String'];
  maxSuites: Scalars['Int'];
  name: Scalars['String'];
};

/** An edge in a connection. */
export type LocationEdge = {
  __typename?: 'LocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Location>;
};

/** Arguments for updating a location */
export type LocationUpdateInput = {
  address?: InputMaybe<Scalars['String']>;
  maxSuites?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Root mutation type */
export type Mutation = {
  __typename?: 'Mutation';
  clientCreate: Client;
  clientUpdate: Client;
  contractCreate: Contract;
  documentGuestUpdate: Document;
  documentRenew: Document;
  documentUpdate: Document;
  locationCreate: Location;
  locationDelete: Location;
  locationUpdate: Location;
  uploadDocument: Document;
};


/** Root mutation type */
export type MutationClientCreateArgs = {
  data: ClientCreateInput;
  options?: InputMaybe<ClientCreateOptionsInput>;
};


/** Root mutation type */
export type MutationClientUpdateArgs = {
  data: ClientUpdateInput;
  id: Scalars['ID'];
};


/** Root mutation type */
export type MutationContractCreateArgs = {
  data: ContractCreateInput;
  options?: InputMaybe<ContractCreateOptionsInput>;
};


/** Root mutation type */
export type MutationDocumentGuestUpdateArgs = {
  data: DocumentGuestUpdateInput;
  id: Scalars['ID'];
  token: Scalars['String'];
};


/** Root mutation type */
export type MutationDocumentRenewArgs = {
  data: DocumentRenewInput;
  id: Scalars['ID'];
};


/** Root mutation type */
export type MutationDocumentUpdateArgs = {
  data: DocumentUpdateInput;
  id: Scalars['ID'];
};


/** Root mutation type */
export type MutationLocationCreateArgs = {
  data: LocationCreateInput;
};


/** Root mutation type */
export type MutationLocationDeleteArgs = {
  id: Scalars['ID'];
};


/** Root mutation type */
export type MutationLocationUpdateArgs = {
  data: LocationUpdateInput;
  id: Scalars['ID'];
};


/** Root mutation type */
export type MutationUploadDocumentArgs = {
  clientId: Scalars['ID'];
  contractId?: InputMaybe<Scalars['ID']>;
  file: Scalars['Upload'];
  type: Scalars['String'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Root query type */
export type Query = {
  __typename?: 'Query';
  client: Client;
  clients: ClientConnection;
  contract: Contract;
  contracts: ContractConnection;
  currentUser?: Maybe<User>;
  document: Document;
  documentTemplates: DocumentTemplateConnection;
  documentWithToken: Document;
  documents: DocumentConnection;
  documentsByOwner: DocumentConnection;
  leaseApplication: LeaseApplication;
  location: Location;
  locations: LocationConnection;
  renewal: Renewal;
  stats: Stats;
  todos: TodoConnection;
};


/** Root query type */
export type QueryClientArgs = {
  id: Scalars['ID'];
};


/** Root query type */
export type QueryClientsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Root query type */
export type QueryContractArgs = {
  token: Scalars['String'];
};


/** Root query type */
export type QueryContractsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Root query type */
export type QueryDocumentArgs = {
  id: Scalars['ID'];
};


/** Root query type */
export type QueryDocumentTemplatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Root query type */
export type QueryDocumentWithTokenArgs = {
  id: Scalars['ID'];
  token: Scalars['String'];
};


/** Root query type */
export type QueryDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Root query type */
export type QueryDocumentsByOwnerArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  ownerId: Scalars['ID'];
  ownerType: DocumentOwnerType;
};


/** Root query type */
export type QueryLeaseApplicationArgs = {
  token: Scalars['String'];
};


/** Root query type */
export type QueryLocationArgs = {
  id: Scalars['ID'];
};


/** Root query type */
export type QueryLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Root query type */
export type QueryRenewalArgs = {
  token: Scalars['String'];
};


/** Root query type */
export type QueryTodosArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** A renewal object that allows the renewal of a document */
export type Renewal = {
  __typename?: 'Renewal';
  /** link to eSign the document */
  documentLink?: Maybe<Scalars['String']>;
  /** Primary key */
  id: Scalars['ID'];
  /** Date in which the related document was signed */
  usedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** General stats */
export type Stats = {
  __typename?: 'Stats';
  /** Suites available in all locations */
  availableSuitesCount: Scalars['Int'];
  /** Client count */
  clientCount: Scalars['Int'];
  /** Current contract count */
  contractCount: Scalars['Int'];
  /** Contracts expiring in current month */
  expiringContractCount: Scalars['Int'];
};

/** A To-do's target object */
export type Target = {
  /** Primary key */
  id: Scalars['ID'];
  /** Object Name */
  name: Scalars['String'];
};

/** A To-do item */
export type Todo = {
  __typename?: 'Todo';
  /** Deadline */
  deadline: Scalars['ISO8601Date'];
  /** Description */
  description: Scalars['String'];
  /** Completion status */
  done: Scalars['Boolean'];
  /** Primary key */
  id: Scalars['ID'];
  /** Type */
  kind: TodoKind;
  /** To-do's target object */
  target: Target;
};

/** The connection type for Todo. */
export type TodoConnection = {
  __typename?: 'TodoConnection';
  /** A list of edges. */
  edges: Array<TodoEdge>;
  /** A list of nodes. */
  nodes: Array<Todo>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TodoEdge = {
  __typename?: 'TodoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Todo>;
};

export enum TodoKind {
  Expiration = 'EXPIRATION',
  NoExpirationDate = 'NO_EXPIRATION_DATE'
}

/** A user */
export type User = {
  __typename?: 'User';
  /** Unique user email */
  email: Scalars['String'];
  /** Primary key */
  id: Scalars['ID'];
};

export type ContractCreateMutationVariables = Exact<{
  data: ContractCreateInput;
  options?: InputMaybe<ContractCreateOptionsInput>;
}>;


export type ContractCreateMutation = { __typename?: 'Mutation', contractCreate: { __typename?: 'Contract', endOn: any, id: string, startOn: any, suite: number, documents: { __typename?: 'DocumentConnection', edges: Array<{ __typename?: 'DocumentEdge', node?: { __typename?: 'Document', createdAt: any, fileUrl?: string | null, folderName: string, id: string, name: string, status: string } | null }> }, location: { __typename?: 'Location', address: string, availableSuites: Array<number>, id: string } } };

export type ContractsListQueryVariables = Exact<{
  clientId: Scalars['ID'];
}>;


export type ContractsListQuery = { __typename?: 'Query', contracts: { __typename?: 'ContractConnection', edges: Array<{ __typename?: 'ContractEdge', node?: { __typename?: 'Contract', endOn: any, id: string, startOn: any, suite: number, location: { __typename?: 'Location', address: string, id: string } } | null }> } };

export type DocumentsQueryVariables = Exact<{
  clientId: Scalars['ID'];
}>;


export type DocumentsQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentConnection', edges: Array<{ __typename?: 'DocumentEdge', node?: { __typename?: 'Document', createdAt: any, fileUrl?: string | null, folderName: string, id: string, name: string, status: string } | null }> } };

export type UploadDocumentMutationVariables = Exact<{
  clientId: Scalars['ID'];
  file: Scalars['Upload'];
  type: Scalars['String'];
  contractId: Scalars['ID'];
}>;


export type UploadDocumentMutation = { __typename?: 'Mutation', uploadDocument: { __typename?: 'Document', createdAt: any, fileUrl?: string | null, folderName: string, id: string, name: string, status: string } };

export type DocumentsNodeFieldsFragment = { __typename?: 'Document', createdAt: any, fileUrl?: string | null, folderName: string, id: string, name: string, status: string };

export type ClientQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ClientQuery = { __typename?: 'Query', client: { __typename?: 'Client', createdAt: any, email: string, firstName: string, fullName: string, id: string, lastName: string } };

export type DocumentForRenewalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DocumentForRenewalQuery = { __typename?: 'Query', document: { __typename?: 'Document', esign: boolean, expiresOn?: any | null, id: string, name: string, nonExpiring: boolean } };

export type DocumentTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type DocumentTemplatesQuery = { __typename?: 'Query', documentTemplates: { __typename?: 'DocumentTemplateConnection', edges: Array<{ __typename?: 'DocumentTemplateEdge', node?: { __typename?: 'DocumentTemplate', esignTemplateId: string, id: string, name: string } | null }> } };

export type DocumentRenewMutationVariables = Exact<{
  data: DocumentRenewInput;
  id: Scalars['ID'];
}>;


export type DocumentRenewMutation = { __typename?: 'Mutation', documentRenew: { __typename?: 'Document', esign: boolean, expiresOn?: any | null, fileUrl?: string | null, id: string, nonExpiring: boolean, status: string, todos: { __typename?: 'TodoConnection', edges: Array<{ __typename?: 'TodoEdge', node?: { __typename?: 'Todo', done: boolean, id: string } | null }> } } };

export type DocumentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DocumentQuery = { __typename?: 'Query', document: { __typename?: 'Document', expiresOn?: any | null, id: string, name: string, nonExpiring: boolean } };

export type DocumentUpdateMutationVariables = Exact<{
  data: DocumentUpdateInput;
  id: Scalars['ID'];
}>;


export type DocumentUpdateMutation = { __typename?: 'Mutation', documentUpdate: { __typename?: 'Document', expiresOn?: any | null, id: string, nonExpiring: boolean, todos: { __typename?: 'TodoConnection', edges: Array<{ __typename?: 'TodoEdge', node?: { __typename?: 'Todo', done: boolean, id: string } | null }> } } };

export type ClientsListQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientsListQuery = { __typename?: 'Query', clients: { __typename?: 'ClientConnection', edges: Array<{ __typename?: 'ClientEdge', node?: { __typename?: 'Client', createdAt: any, fullName: string, id: string, status: string, todoCount: number } | null }> } };

export type ClientsListNodeFieldsFragment = { __typename?: 'Client', createdAt: any, fullName: string, id: string, status: string, todoCount: number };

export type ClientUpdateMutationVariables = Exact<{
  data: ClientUpdateInput;
  id: Scalars['ID'];
}>;


export type ClientUpdateMutation = { __typename?: 'Mutation', clientUpdate: { __typename?: 'Client', firstName: string, lastName: string, createdAt: any, fullName: string, id: string, status: string, todoCount: number } };

export type ClientCreateMutationVariables = Exact<{
  data: ClientCreateInput;
  options?: InputMaybe<ClientCreateOptionsInput>;
}>;


export type ClientCreateMutation = { __typename?: 'Mutation', clientCreate: { __typename?: 'Client', createdAt: any, fullName: string, id: string, status: string, todoCount: number } };

export type StatsQueryVariables = Exact<{ [key: string]: never; }>;


export type StatsQuery = { __typename?: 'Query', stats: { __typename?: 'Stats', availableSuitesCount: number, clientCount: number, contractCount: number, expiringContractCount: number } };

export type LocationUpdateMutationVariables = Exact<{
  data: LocationUpdateInput;
  id: Scalars['ID'];
}>;


export type LocationUpdateMutation = { __typename?: 'Mutation', locationUpdate: { __typename?: 'Location', address: string, availableSuites: Array<number>, id: string, maxSuites: number, name: string } };

export type LocationDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LocationDeleteMutation = { __typename?: 'Mutation', locationDelete: { __typename?: 'Location', id: string } };

export type LocationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LocationQuery = { __typename?: 'Query', location: { __typename?: 'Location', address: string, availableSuites: Array<number>, id: string, maxSuites: number, name: string } };

export type LocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationsQuery = { __typename?: 'Query', locations: { __typename?: 'LocationConnection', edges: Array<{ __typename?: 'LocationEdge', node?: { __typename?: 'Location', address: string, availableSuites: Array<number>, id: string, maxSuites: number, name: string } | null }> } };

export type LocationCreateMutationVariables = Exact<{
  data: LocationCreateInput;
}>;


export type LocationCreateMutation = { __typename?: 'Mutation', locationCreate: { __typename?: 'Location', address: string, availableSuites: Array<number>, id: string, maxSuites: number, name: string } };

export type SuiteLocationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SuiteLocationQuery = { __typename?: 'Query', location: { __typename?: 'Location', address: string, availableSuites: Array<number>, id: string, maxSuites: number, contracts: { __typename?: 'ContractConnection', edges: Array<{ __typename?: 'ContractEdge', node?: { __typename?: 'Contract', endOn: any, startOn: any, suite: number, client: { __typename?: 'Client', createdAt: any, fullName: string } } | null }> } } };

export type TodosQueryVariables = Exact<{ [key: string]: never; }>;


export type TodosQuery = { __typename?: 'Query', todos: { __typename?: 'TodoConnection', edges: Array<{ __typename?: 'TodoEdge', node?: { __typename?: 'Todo', deadline: any, description: string, done: boolean, id: string, kind: TodoKind, target: { __typename?: 'Document', id: string, name: string, client: { __typename?: 'Client', fullName: string, id: string } } } | null }> } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, email: string } | null };

export type DocumentGuestUpdateMutationVariables = Exact<{
  data: DocumentGuestUpdateInput;
  id: Scalars['ID'];
  token: Scalars['String'];
}>;


export type DocumentGuestUpdateMutation = { __typename?: 'Mutation', documentGuestUpdate: { __typename?: 'Document', fileUrl?: string | null, id: string, status: string } };

export type ContractQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type ContractQuery = { __typename?: 'Query', contract: { __typename?: 'Contract', id: string, suite: number, usedAt?: any | null, documents: { __typename?: 'DocumentConnection', edges: Array<{ __typename?: 'DocumentEdge', node?: { __typename?: 'Document', esign: boolean, id: string, name: string, status: string } | null }> }, location: { __typename?: 'Location', address: string, id: string } } };

export type DocumentWithTokenQueryVariables = Exact<{
  id: Scalars['ID'];
  token: Scalars['String'];
}>;


export type DocumentWithTokenQuery = { __typename?: 'Query', documentWithToken: { __typename?: 'Document', description: string, esign: boolean, esignLink?: string | null, fileUrl?: string | null, id: string, name: string, status: string } };

export type LeaseApplicationQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type LeaseApplicationQuery = { __typename?: 'Query', leaseApplication: { __typename?: 'LeaseApplication', documentLink?: string | null, id: string, usedAt?: any | null } };

export type RenewalQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type RenewalQuery = { __typename?: 'Query', renewal: { __typename?: 'Renewal', documentLink?: string | null, id: string, usedAt?: any | null } };

export const DocumentsNodeFieldsFragmentDoc = gql`
    fragment DocumentsNodeFields on Document {
  createdAt
  fileUrl
  folderName
  id
  name
  status
}
    `;
export const ClientsListNodeFieldsFragmentDoc = gql`
    fragment ClientsListNodeFields on Client {
  createdAt
  fullName
  id
  status
  todoCount
}
    `;
export const ContractCreateDocument = gql`
    mutation ContractCreate($data: ContractCreateInput!, $options: ContractCreateOptionsInput) {
  contractCreate(data: $data, options: $options) {
    documents {
      edges {
        node {
          ...DocumentsNodeFields
        }
      }
    }
    endOn
    id
    location {
      address
      availableSuites
      id
    }
    startOn
    suite
  }
}
    ${DocumentsNodeFieldsFragmentDoc}`;
export type ContractCreateMutationFn = Apollo.MutationFunction<ContractCreateMutation, ContractCreateMutationVariables>;

/**
 * __useContractCreateMutation__
 *
 * To run a mutation, you first call `useContractCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractCreateMutation, { data, loading, error }] = useContractCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useContractCreateMutation(baseOptions?: Apollo.MutationHookOptions<ContractCreateMutation, ContractCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContractCreateMutation, ContractCreateMutationVariables>(ContractCreateDocument, options);
      }
export type ContractCreateMutationHookResult = ReturnType<typeof useContractCreateMutation>;
export type ContractCreateMutationResult = Apollo.MutationResult<ContractCreateMutation>;
export type ContractCreateMutationOptions = Apollo.BaseMutationOptions<ContractCreateMutation, ContractCreateMutationVariables>;
export const ContractsListDocument = gql`
    query ContractsList($clientId: ID!) {
  contracts(clientId: $clientId) {
    edges {
      node {
        endOn
        id
        location {
          address
          id
        }
        startOn
        suite
      }
    }
  }
}
    `;

/**
 * __useContractsListQuery__
 *
 * To run a query within a React component, call `useContractsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractsListQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useContractsListQuery(baseOptions: Apollo.QueryHookOptions<ContractsListQuery, ContractsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractsListQuery, ContractsListQueryVariables>(ContractsListDocument, options);
      }
export function useContractsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractsListQuery, ContractsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractsListQuery, ContractsListQueryVariables>(ContractsListDocument, options);
        }
export type ContractsListQueryHookResult = ReturnType<typeof useContractsListQuery>;
export type ContractsListLazyQueryHookResult = ReturnType<typeof useContractsListLazyQuery>;
export type ContractsListQueryResult = Apollo.QueryResult<ContractsListQuery, ContractsListQueryVariables>;
export const DocumentsDocument = gql`
    query Documents($clientId: ID!) {
  documents(clientId: $clientId) {
    edges {
      node {
        ...DocumentsNodeFields
      }
    }
  }
}
    ${DocumentsNodeFieldsFragmentDoc}`;

/**
 * __useDocumentsQuery__
 *
 * To run a query within a React component, call `useDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useDocumentsQuery(baseOptions: Apollo.QueryHookOptions<DocumentsQuery, DocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentsQuery, DocumentsQueryVariables>(DocumentsDocument, options);
      }
export function useDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentsQuery, DocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentsQuery, DocumentsQueryVariables>(DocumentsDocument, options);
        }
export type DocumentsQueryHookResult = ReturnType<typeof useDocumentsQuery>;
export type DocumentsLazyQueryHookResult = ReturnType<typeof useDocumentsLazyQuery>;
export type DocumentsQueryResult = Apollo.QueryResult<DocumentsQuery, DocumentsQueryVariables>;
export const UploadDocumentDocument = gql`
    mutation UploadDocument($clientId: ID!, $file: Upload!, $type: String!, $contractId: ID!) {
  uploadDocument(
    clientId: $clientId
    file: $file
    type: $type
    contractId: $contractId
  ) {
    ...DocumentsNodeFields
  }
}
    ${DocumentsNodeFieldsFragmentDoc}`;
export type UploadDocumentMutationFn = Apollo.MutationFunction<UploadDocumentMutation, UploadDocumentMutationVariables>;

/**
 * __useUploadDocumentMutation__
 *
 * To run a mutation, you first call `useUploadDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDocumentMutation, { data, loading, error }] = useUploadDocumentMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      file: // value for 'file'
 *      type: // value for 'type'
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useUploadDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UploadDocumentMutation, UploadDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadDocumentMutation, UploadDocumentMutationVariables>(UploadDocumentDocument, options);
      }
export type UploadDocumentMutationHookResult = ReturnType<typeof useUploadDocumentMutation>;
export type UploadDocumentMutationResult = Apollo.MutationResult<UploadDocumentMutation>;
export type UploadDocumentMutationOptions = Apollo.BaseMutationOptions<UploadDocumentMutation, UploadDocumentMutationVariables>;
export const ClientDocument = gql`
    query Client($id: ID!) {
  client(id: $id) {
    createdAt
    email
    firstName
    fullName
    id
    lastName
  }
}
    `;

/**
 * __useClientQuery__
 *
 * To run a query within a React component, call `useClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientQuery(baseOptions: Apollo.QueryHookOptions<ClientQuery, ClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientQuery, ClientQueryVariables>(ClientDocument, options);
      }
export function useClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientQuery, ClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientQuery, ClientQueryVariables>(ClientDocument, options);
        }
export type ClientQueryHookResult = ReturnType<typeof useClientQuery>;
export type ClientLazyQueryHookResult = ReturnType<typeof useClientLazyQuery>;
export type ClientQueryResult = Apollo.QueryResult<ClientQuery, ClientQueryVariables>;
export const DocumentForRenewalDocument = gql`
    query DocumentForRenewal($id: ID!) {
  document(id: $id) {
    esign
    expiresOn
    id
    name
    nonExpiring
  }
}
    `;

/**
 * __useDocumentForRenewalQuery__
 *
 * To run a query within a React component, call `useDocumentForRenewalQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentForRenewalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentForRenewalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDocumentForRenewalQuery(baseOptions: Apollo.QueryHookOptions<DocumentForRenewalQuery, DocumentForRenewalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentForRenewalQuery, DocumentForRenewalQueryVariables>(DocumentForRenewalDocument, options);
      }
export function useDocumentForRenewalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentForRenewalQuery, DocumentForRenewalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentForRenewalQuery, DocumentForRenewalQueryVariables>(DocumentForRenewalDocument, options);
        }
export type DocumentForRenewalQueryHookResult = ReturnType<typeof useDocumentForRenewalQuery>;
export type DocumentForRenewalLazyQueryHookResult = ReturnType<typeof useDocumentForRenewalLazyQuery>;
export type DocumentForRenewalQueryResult = Apollo.QueryResult<DocumentForRenewalQuery, DocumentForRenewalQueryVariables>;
export const DocumentTemplatesDocument = gql`
    query DocumentTemplates {
  documentTemplates {
    edges {
      node {
        esignTemplateId
        id
        name
      }
    }
  }
}
    `;

/**
 * __useDocumentTemplatesQuery__
 *
 * To run a query within a React component, call `useDocumentTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDocumentTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<DocumentTemplatesQuery, DocumentTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentTemplatesQuery, DocumentTemplatesQueryVariables>(DocumentTemplatesDocument, options);
      }
export function useDocumentTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentTemplatesQuery, DocumentTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentTemplatesQuery, DocumentTemplatesQueryVariables>(DocumentTemplatesDocument, options);
        }
export type DocumentTemplatesQueryHookResult = ReturnType<typeof useDocumentTemplatesQuery>;
export type DocumentTemplatesLazyQueryHookResult = ReturnType<typeof useDocumentTemplatesLazyQuery>;
export type DocumentTemplatesQueryResult = Apollo.QueryResult<DocumentTemplatesQuery, DocumentTemplatesQueryVariables>;
export const DocumentRenewDocument = gql`
    mutation DocumentRenew($data: DocumentRenewInput!, $id: ID!) {
  documentRenew(data: $data, id: $id) {
    esign
    expiresOn
    fileUrl
    id
    nonExpiring
    status
    todos {
      edges {
        node {
          done
          id
        }
      }
    }
  }
}
    `;
export type DocumentRenewMutationFn = Apollo.MutationFunction<DocumentRenewMutation, DocumentRenewMutationVariables>;

/**
 * __useDocumentRenewMutation__
 *
 * To run a mutation, you first call `useDocumentRenewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentRenewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentRenewMutation, { data, loading, error }] = useDocumentRenewMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDocumentRenewMutation(baseOptions?: Apollo.MutationHookOptions<DocumentRenewMutation, DocumentRenewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DocumentRenewMutation, DocumentRenewMutationVariables>(DocumentRenewDocument, options);
      }
export type DocumentRenewMutationHookResult = ReturnType<typeof useDocumentRenewMutation>;
export type DocumentRenewMutationResult = Apollo.MutationResult<DocumentRenewMutation>;
export type DocumentRenewMutationOptions = Apollo.BaseMutationOptions<DocumentRenewMutation, DocumentRenewMutationVariables>;
export const DocumentDocument = gql`
    query Document($id: ID!) {
  document(id: $id) {
    expiresOn
    id
    name
    nonExpiring
  }
}
    `;

/**
 * __useDocumentQuery__
 *
 * To run a query within a React component, call `useDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDocumentQuery(baseOptions: Apollo.QueryHookOptions<DocumentQuery, DocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentQuery, DocumentQueryVariables>(DocumentDocument, options);
      }
export function useDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentQuery, DocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentQuery, DocumentQueryVariables>(DocumentDocument, options);
        }
export type DocumentQueryHookResult = ReturnType<typeof useDocumentQuery>;
export type DocumentLazyQueryHookResult = ReturnType<typeof useDocumentLazyQuery>;
export type DocumentQueryResult = Apollo.QueryResult<DocumentQuery, DocumentQueryVariables>;
export const DocumentUpdateDocument = gql`
    mutation DocumentUpdate($data: DocumentUpdateInput!, $id: ID!) {
  documentUpdate(data: $data, id: $id) {
    expiresOn
    id
    nonExpiring
    todos {
      edges {
        node {
          done
          id
        }
      }
    }
  }
}
    `;
export type DocumentUpdateMutationFn = Apollo.MutationFunction<DocumentUpdateMutation, DocumentUpdateMutationVariables>;

/**
 * __useDocumentUpdateMutation__
 *
 * To run a mutation, you first call `useDocumentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentUpdateMutation, { data, loading, error }] = useDocumentUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDocumentUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DocumentUpdateMutation, DocumentUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DocumentUpdateMutation, DocumentUpdateMutationVariables>(DocumentUpdateDocument, options);
      }
export type DocumentUpdateMutationHookResult = ReturnType<typeof useDocumentUpdateMutation>;
export type DocumentUpdateMutationResult = Apollo.MutationResult<DocumentUpdateMutation>;
export type DocumentUpdateMutationOptions = Apollo.BaseMutationOptions<DocumentUpdateMutation, DocumentUpdateMutationVariables>;
export const ClientsListDocument = gql`
    query ClientsList {
  clients {
    edges {
      node {
        ...ClientsListNodeFields
      }
    }
  }
}
    ${ClientsListNodeFieldsFragmentDoc}`;

/**
 * __useClientsListQuery__
 *
 * To run a query within a React component, call `useClientsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientsListQuery(baseOptions?: Apollo.QueryHookOptions<ClientsListQuery, ClientsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientsListQuery, ClientsListQueryVariables>(ClientsListDocument, options);
      }
export function useClientsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientsListQuery, ClientsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientsListQuery, ClientsListQueryVariables>(ClientsListDocument, options);
        }
export type ClientsListQueryHookResult = ReturnType<typeof useClientsListQuery>;
export type ClientsListLazyQueryHookResult = ReturnType<typeof useClientsListLazyQuery>;
export type ClientsListQueryResult = Apollo.QueryResult<ClientsListQuery, ClientsListQueryVariables>;
export const ClientUpdateDocument = gql`
    mutation ClientUpdate($data: ClientUpdateInput!, $id: ID!) {
  clientUpdate(data: $data, id: $id) {
    ...ClientsListNodeFields
    firstName
    lastName
  }
}
    ${ClientsListNodeFieldsFragmentDoc}`;
export type ClientUpdateMutationFn = Apollo.MutationFunction<ClientUpdateMutation, ClientUpdateMutationVariables>;

/**
 * __useClientUpdateMutation__
 *
 * To run a mutation, you first call `useClientUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientUpdateMutation, { data, loading, error }] = useClientUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ClientUpdateMutation, ClientUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClientUpdateMutation, ClientUpdateMutationVariables>(ClientUpdateDocument, options);
      }
export type ClientUpdateMutationHookResult = ReturnType<typeof useClientUpdateMutation>;
export type ClientUpdateMutationResult = Apollo.MutationResult<ClientUpdateMutation>;
export type ClientUpdateMutationOptions = Apollo.BaseMutationOptions<ClientUpdateMutation, ClientUpdateMutationVariables>;
export const ClientCreateDocument = gql`
    mutation ClientCreate($data: ClientCreateInput!, $options: ClientCreateOptionsInput) {
  clientCreate(data: $data, options: $options) {
    ...ClientsListNodeFields
  }
}
    ${ClientsListNodeFieldsFragmentDoc}`;
export type ClientCreateMutationFn = Apollo.MutationFunction<ClientCreateMutation, ClientCreateMutationVariables>;

/**
 * __useClientCreateMutation__
 *
 * To run a mutation, you first call `useClientCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientCreateMutation, { data, loading, error }] = useClientCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useClientCreateMutation(baseOptions?: Apollo.MutationHookOptions<ClientCreateMutation, ClientCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClientCreateMutation, ClientCreateMutationVariables>(ClientCreateDocument, options);
      }
export type ClientCreateMutationHookResult = ReturnType<typeof useClientCreateMutation>;
export type ClientCreateMutationResult = Apollo.MutationResult<ClientCreateMutation>;
export type ClientCreateMutationOptions = Apollo.BaseMutationOptions<ClientCreateMutation, ClientCreateMutationVariables>;
export const StatsDocument = gql`
    query Stats {
  stats {
    availableSuitesCount
    clientCount
    contractCount
    expiringContractCount
  }
}
    `;

/**
 * __useStatsQuery__
 *
 * To run a query within a React component, call `useStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useStatsQuery(baseOptions?: Apollo.QueryHookOptions<StatsQuery, StatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StatsQuery, StatsQueryVariables>(StatsDocument, options);
      }
export function useStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatsQuery, StatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StatsQuery, StatsQueryVariables>(StatsDocument, options);
        }
export type StatsQueryHookResult = ReturnType<typeof useStatsQuery>;
export type StatsLazyQueryHookResult = ReturnType<typeof useStatsLazyQuery>;
export type StatsQueryResult = Apollo.QueryResult<StatsQuery, StatsQueryVariables>;
export const LocationUpdateDocument = gql`
    mutation LocationUpdate($data: LocationUpdateInput!, $id: ID!) {
  locationUpdate(data: $data, id: $id) {
    address
    availableSuites
    id
    maxSuites
    name
  }
}
    `;
export type LocationUpdateMutationFn = Apollo.MutationFunction<LocationUpdateMutation, LocationUpdateMutationVariables>;

/**
 * __useLocationUpdateMutation__
 *
 * To run a mutation, you first call `useLocationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locationUpdateMutation, { data, loading, error }] = useLocationUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLocationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<LocationUpdateMutation, LocationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocationUpdateMutation, LocationUpdateMutationVariables>(LocationUpdateDocument, options);
      }
export type LocationUpdateMutationHookResult = ReturnType<typeof useLocationUpdateMutation>;
export type LocationUpdateMutationResult = Apollo.MutationResult<LocationUpdateMutation>;
export type LocationUpdateMutationOptions = Apollo.BaseMutationOptions<LocationUpdateMutation, LocationUpdateMutationVariables>;
export const LocationDeleteDocument = gql`
    mutation LocationDelete($id: ID!) {
  locationDelete(id: $id) {
    id
  }
}
    `;
export type LocationDeleteMutationFn = Apollo.MutationFunction<LocationDeleteMutation, LocationDeleteMutationVariables>;

/**
 * __useLocationDeleteMutation__
 *
 * To run a mutation, you first call `useLocationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locationDeleteMutation, { data, loading, error }] = useLocationDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLocationDeleteMutation(baseOptions?: Apollo.MutationHookOptions<LocationDeleteMutation, LocationDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocationDeleteMutation, LocationDeleteMutationVariables>(LocationDeleteDocument, options);
      }
export type LocationDeleteMutationHookResult = ReturnType<typeof useLocationDeleteMutation>;
export type LocationDeleteMutationResult = Apollo.MutationResult<LocationDeleteMutation>;
export type LocationDeleteMutationOptions = Apollo.BaseMutationOptions<LocationDeleteMutation, LocationDeleteMutationVariables>;
export const LocationDocument = gql`
    query Location($id: ID!) {
  location(id: $id) {
    address
    availableSuites
    id
    maxSuites
    name
  }
}
    `;

/**
 * __useLocationQuery__
 *
 * To run a query within a React component, call `useLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLocationQuery(baseOptions: Apollo.QueryHookOptions<LocationQuery, LocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationQuery, LocationQueryVariables>(LocationDocument, options);
      }
export function useLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationQuery, LocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationQuery, LocationQueryVariables>(LocationDocument, options);
        }
export type LocationQueryHookResult = ReturnType<typeof useLocationQuery>;
export type LocationLazyQueryHookResult = ReturnType<typeof useLocationLazyQuery>;
export type LocationQueryResult = Apollo.QueryResult<LocationQuery, LocationQueryVariables>;
export const LocationsDocument = gql`
    query Locations {
  locations {
    edges {
      node {
        address
        availableSuites
        id
        maxSuites
        name
      }
    }
  }
}
    `;

/**
 * __useLocationsQuery__
 *
 * To run a query within a React component, call `useLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocationsQuery(baseOptions?: Apollo.QueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
      }
export function useLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
        }
export type LocationsQueryHookResult = ReturnType<typeof useLocationsQuery>;
export type LocationsLazyQueryHookResult = ReturnType<typeof useLocationsLazyQuery>;
export type LocationsQueryResult = Apollo.QueryResult<LocationsQuery, LocationsQueryVariables>;
export const LocationCreateDocument = gql`
    mutation LocationCreate($data: LocationCreateInput!) {
  locationCreate(data: $data) {
    address
    availableSuites
    id
    maxSuites
    name
  }
}
    `;
export type LocationCreateMutationFn = Apollo.MutationFunction<LocationCreateMutation, LocationCreateMutationVariables>;

/**
 * __useLocationCreateMutation__
 *
 * To run a mutation, you first call `useLocationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locationCreateMutation, { data, loading, error }] = useLocationCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useLocationCreateMutation(baseOptions?: Apollo.MutationHookOptions<LocationCreateMutation, LocationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocationCreateMutation, LocationCreateMutationVariables>(LocationCreateDocument, options);
      }
export type LocationCreateMutationHookResult = ReturnType<typeof useLocationCreateMutation>;
export type LocationCreateMutationResult = Apollo.MutationResult<LocationCreateMutation>;
export type LocationCreateMutationOptions = Apollo.BaseMutationOptions<LocationCreateMutation, LocationCreateMutationVariables>;
export const SuiteLocationDocument = gql`
    query SuiteLocation($id: ID!) {
  location(id: $id) {
    address
    availableSuites
    contracts {
      edges {
        node {
          client {
            createdAt
            fullName
          }
          endOn
          startOn
          suite
        }
      }
    }
    id
    maxSuites
  }
}
    `;

/**
 * __useSuiteLocationQuery__
 *
 * To run a query within a React component, call `useSuiteLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuiteLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuiteLocationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuiteLocationQuery(baseOptions: Apollo.QueryHookOptions<SuiteLocationQuery, SuiteLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuiteLocationQuery, SuiteLocationQueryVariables>(SuiteLocationDocument, options);
      }
export function useSuiteLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuiteLocationQuery, SuiteLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuiteLocationQuery, SuiteLocationQueryVariables>(SuiteLocationDocument, options);
        }
export type SuiteLocationQueryHookResult = ReturnType<typeof useSuiteLocationQuery>;
export type SuiteLocationLazyQueryHookResult = ReturnType<typeof useSuiteLocationLazyQuery>;
export type SuiteLocationQueryResult = Apollo.QueryResult<SuiteLocationQuery, SuiteLocationQueryVariables>;
export const TodosDocument = gql`
    query Todos {
  todos {
    edges {
      node {
        deadline
        description
        done
        id
        kind
        target {
          id
          name
          ... on Document {
            client {
              fullName
              id
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTodosQuery__
 *
 * To run a query within a React component, call `useTodosQuery` and pass it any options that fit your needs.
 * When your component renders, `useTodosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTodosQuery({
 *   variables: {
 *   },
 * });
 */
export function useTodosQuery(baseOptions?: Apollo.QueryHookOptions<TodosQuery, TodosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TodosQuery, TodosQueryVariables>(TodosDocument, options);
      }
export function useTodosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TodosQuery, TodosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TodosQuery, TodosQueryVariables>(TodosDocument, options);
        }
export type TodosQueryHookResult = ReturnType<typeof useTodosQuery>;
export type TodosLazyQueryHookResult = ReturnType<typeof useTodosLazyQuery>;
export type TodosQueryResult = Apollo.QueryResult<TodosQuery, TodosQueryVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    id
    email
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const DocumentGuestUpdateDocument = gql`
    mutation DocumentGuestUpdate($data: DocumentGuestUpdateInput!, $id: ID!, $token: String!) {
  documentGuestUpdate(data: $data, id: $id, token: $token) {
    fileUrl
    id
    status
  }
}
    `;
export type DocumentGuestUpdateMutationFn = Apollo.MutationFunction<DocumentGuestUpdateMutation, DocumentGuestUpdateMutationVariables>;

/**
 * __useDocumentGuestUpdateMutation__
 *
 * To run a mutation, you first call `useDocumentGuestUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentGuestUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentGuestUpdateMutation, { data, loading, error }] = useDocumentGuestUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useDocumentGuestUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DocumentGuestUpdateMutation, DocumentGuestUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DocumentGuestUpdateMutation, DocumentGuestUpdateMutationVariables>(DocumentGuestUpdateDocument, options);
      }
export type DocumentGuestUpdateMutationHookResult = ReturnType<typeof useDocumentGuestUpdateMutation>;
export type DocumentGuestUpdateMutationResult = Apollo.MutationResult<DocumentGuestUpdateMutation>;
export type DocumentGuestUpdateMutationOptions = Apollo.BaseMutationOptions<DocumentGuestUpdateMutation, DocumentGuestUpdateMutationVariables>;
export const ContractDocument = gql`
    query Contract($token: String!) {
  contract(token: $token) {
    documents {
      edges {
        node {
          esign
          id
          name
          status
        }
      }
    }
    id
    location {
      address
      id
    }
    suite
    usedAt
  }
}
    `;

/**
 * __useContractQuery__
 *
 * To run a query within a React component, call `useContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useContractQuery(baseOptions: Apollo.QueryHookOptions<ContractQuery, ContractQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractQuery, ContractQueryVariables>(ContractDocument, options);
      }
export function useContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractQuery, ContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractQuery, ContractQueryVariables>(ContractDocument, options);
        }
export type ContractQueryHookResult = ReturnType<typeof useContractQuery>;
export type ContractLazyQueryHookResult = ReturnType<typeof useContractLazyQuery>;
export type ContractQueryResult = Apollo.QueryResult<ContractQuery, ContractQueryVariables>;
export const DocumentWithTokenDocument = gql`
    query DocumentWithToken($id: ID!, $token: String!) {
  documentWithToken(id: $id, token: $token) {
    description
    esign
    esignLink
    fileUrl
    id
    name
    status
  }
}
    `;

/**
 * __useDocumentWithTokenQuery__
 *
 * To run a query within a React component, call `useDocumentWithTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentWithTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentWithTokenQuery({
 *   variables: {
 *      id: // value for 'id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useDocumentWithTokenQuery(baseOptions: Apollo.QueryHookOptions<DocumentWithTokenQuery, DocumentWithTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentWithTokenQuery, DocumentWithTokenQueryVariables>(DocumentWithTokenDocument, options);
      }
export function useDocumentWithTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentWithTokenQuery, DocumentWithTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentWithTokenQuery, DocumentWithTokenQueryVariables>(DocumentWithTokenDocument, options);
        }
export type DocumentWithTokenQueryHookResult = ReturnType<typeof useDocumentWithTokenQuery>;
export type DocumentWithTokenLazyQueryHookResult = ReturnType<typeof useDocumentWithTokenLazyQuery>;
export type DocumentWithTokenQueryResult = Apollo.QueryResult<DocumentWithTokenQuery, DocumentWithTokenQueryVariables>;
export const LeaseApplicationDocument = gql`
    query LeaseApplication($token: String!) {
  leaseApplication(token: $token) {
    documentLink
    id
    usedAt
  }
}
    `;

/**
 * __useLeaseApplicationQuery__
 *
 * To run a query within a React component, call `useLeaseApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeaseApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaseApplicationQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useLeaseApplicationQuery(baseOptions: Apollo.QueryHookOptions<LeaseApplicationQuery, LeaseApplicationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeaseApplicationQuery, LeaseApplicationQueryVariables>(LeaseApplicationDocument, options);
      }
export function useLeaseApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeaseApplicationQuery, LeaseApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeaseApplicationQuery, LeaseApplicationQueryVariables>(LeaseApplicationDocument, options);
        }
export type LeaseApplicationQueryHookResult = ReturnType<typeof useLeaseApplicationQuery>;
export type LeaseApplicationLazyQueryHookResult = ReturnType<typeof useLeaseApplicationLazyQuery>;
export type LeaseApplicationQueryResult = Apollo.QueryResult<LeaseApplicationQuery, LeaseApplicationQueryVariables>;
export const RenewalDocument = gql`
    query Renewal($token: String!) {
  renewal(token: $token) {
    documentLink
    id
    usedAt
  }
}
    `;

/**
 * __useRenewalQuery__
 *
 * To run a query within a React component, call `useRenewalQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenewalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenewalQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRenewalQuery(baseOptions: Apollo.QueryHookOptions<RenewalQuery, RenewalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RenewalQuery, RenewalQueryVariables>(RenewalDocument, options);
      }
export function useRenewalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RenewalQuery, RenewalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RenewalQuery, RenewalQueryVariables>(RenewalDocument, options);
        }
export type RenewalQueryHookResult = ReturnType<typeof useRenewalQuery>;
export type RenewalLazyQueryHookResult = ReturnType<typeof useRenewalLazyQuery>;
export type RenewalQueryResult = Apollo.QueryResult<RenewalQuery, RenewalQueryVariables>;